module.exports = __webpack_public_path__ + "static/img/安徽五一学堂.4cccc1a1.png";